import { makeStyles } from "@material-ui/core";

export const useTableManagementStyles = makeStyles((theme) => ({
  tableWrapper: {
    marginTop: "1rem",
  },
}));
